const skills = {
  1: [
    {
      title: "HTML",
      level: 6,
    },
    {
      title: "CSS",
      level: 5,
    },
    {
      title: "Flutter",
      level: 6,
    },
    {
      title: "JavaScript",
      level: 5,
    },
   
    {
      title: "Tailwind CSS",
      level: 4,
    },
    {
      title: "React JS",
      level: 4,
    },
    {
      title: "Figma",
      level: 4,
    },
    {
      title: "A. Photoshop",
      level: 4,
    },
    {
      title: "A. Illustrator",
      level: 4,
    },
  ],
  2: [
    {
      title: "PostgreSQL",
      level: 5,
    },
    {
      title: "Node.js",
      level: 6,
    },
    {
      title: "MongoDB",
      level: 5,
    },
    {
      title: "Git",
      level: 4,
    },
    {
      title: "PHP",
      level: 1,
    },
    {
      title: "SQL",
      level: 4,
    },
    {
      title: "Express.js",
      level: 5,
    },
  ],
};

export default skills;
